<template>
  <div>

    <!-- Filters. Rebuilt on the shared KarroFin FilterBar: same endpoint, same
         params -- only the presentation moved. One filter, so it uses the bar's
         own date control rather than passing a field through the slot. -->
    <FilterBar
      :show-search="false"
      :date-range.sync="filter.daterange"
      :advanced-count="activeChips.length"
      @change="onDateChange()"
      @reset="resetFilters"
    >
      <template #chips>
        <v-chip
          v-for="c in activeChips"
          :key="c.key"
          small
          close
          class="kf-fchip"
          @click:close="clearFilter(c.key)"
        >
          <strong>{{ c.label }}:</strong>&nbsp;{{ c.value }}
        </v-chip>
      </template>
    </FilterBar>


    <v-card flat>
      <v-data-table
          :disable-sort="true"
          :headers="headers"
          :items="review_list"
          :items-per-page="$keys.PAGE_LENGTH"
          :loading="table_loading"
          class="border-a border-0 custome-header-bg"
          hide-default-footer
      >
        <template v-slot:item.name="{ item }">
          <div class="py-2">
            <p>{{ item.name }}</p>
            <p>{{ item.mobile }}</p>
          </div>
        </template>

        <template v-slot:item.rating="{ item }">
          <div class="py-2">
            <v-rating
                v-model="item.rating"
                background-color="secondary_2"
                color="secondary_2"
                dense
                half-increments
                readonly
            ></v-rating>
<!--            <p class="text-center">( {{ item.rating }} )</p>-->
          </div>
        </template>

      </v-data-table>
    </v-card>

    <v-pagination
        v-model="page_number"
        :length="total_page_count"
        :total-visible="7"
        class="custome-pagination"
        @input="getReviewList"
    ></v-pagination>
  </div>
</template>
<script>
import {
  getDefaultSignupDateRangeIso,
  formatSignupDateRangeDisplay,
} from "@/utils/defaultSignupDateRange";
import {mapGetters} from "vuex";
import fmt from "@/app-js/karrofin/format";
import FilterBar from "@/components/karrofin/FilterBar.vue";

export default {
  components: {
    FilterBar,
  },
  data() {
    return {
      table_loading: false,
      page_number: 1,
      total_page_count: 0,
      review_list: [],
      date_range: [],
      headers: [
        {text: 'Customer Details', value: 'name'},
        {text: 'Rating', value: 'rating', align: 'center'},
        {text: 'Review', value: 'review'},
        {text: 'Feedback', value: 'feedback'},
        {text: 'Date', value: 'created', width: "120px"},
      ],
      filter: {
        daterange: getDefaultSignupDateRangeIso(),
        display_daterange: formatSignupDateRangeDisplay(getDefaultSignupDateRangeIso()),
        today: new Date().toISOString().substr(0, 10),
      },
    }
  },
  computed: {
    ...mapGetters({
      search_query: 'getSearchText'
    }),
    /** One entry per applied filter, for the chip row. */
    activeChips() {
      const r = this.filter.daterange;
      if (!Array.isArray(r) || r.length !== 2 || !r[0] || !r[1]) return [];
      return [
        {
          key: "daterange",
          label: "Date range",
          value: fmt.dateRangeShort(r[0], r[1]),
        },
      ];
    },
  },
  watch: {
    search_query(new_search_query, old_search_query) {
      if (new_search_query != old_search_query) {
        this.getReviewList()
      }

    }
  },
  created() {
    console.log(this.$route.meta.show_back_btn)
    this.getReviewList()
  },
  methods: {
    /** Keeps the display label in step with the raw range. */
    onDateChange() {
      if (this.filter.daterange && this.filter.daterange.length > 1) {
        this.filter.display_daterange = this.formateDisplayDateRange(this.filter.daterange)
      }
      this.getReviewList()
    },
    /** One chip's x: drops the date filter altogether (all dates). */
    clearFilter() {
      this.filter.daterange = []
      this.filter.display_daterange = null
      this.getReviewList()
    },
    /** The bar's Reset: back to the default window the screen opens with. */
    resetFilters() {
      this.filter.daterange = getDefaultSignupDateRangeIso()
      this.filter.display_daterange = formatSignupDateRangeDisplay(this.filter.daterange)
      this.getReviewList()
    },
    formateDisplayDateRange(daterange) {
      console.log(daterange)
      let date1 = daterange[0]
      let date2 = daterange[1]
      let to = "";
      let from = "";
      if (date1 > date2) {
        to = date1
        from = date2
      } else {
        to = date2;
        from = date1
      }
      console.log(from)
      if (!to)
        to = from
      daterange[0] = from
      daterange[1] = to
      from = this.display_date_formate(from)
      to = this.display_date_formate(to)
      return `${from} to ${to}`;
    },
    /* fetching the customer list form server*/
    getReviewList() {
      const self = this;
      self.table_loading = true;
      self.toggle_loading()
      let params = {
        page_number: this.page_number,
        page_length: this.$keys.PAGE_LENGTH,
        search_query: this.search_query,
        from_date: this.filter.daterange[0],
        to_date: this.filter.daterange[1],
      };
      console.log(params);
      const successHandler = (response) => {
        if (response.data.success) {
          self.review_list = response.data.review_list;
          self.total_page_count = response.data.total_page_count;
        }
      };
      const finallyHandler = () => {
        self.table_loading = false;
        // self.toggle_loading()
      };

      self.request_GET(self, self.$urls.REVIEW_LIST, params, successHandler, null,
          null, finallyHandler);
    },
  }
}

</script>